module.exports = __webpack_public_path__ + "img/campolivre-logo.e78a081d.png";